import bu from './businessUnit/routes';
import cash from './cash/routes';
import sales from './sales/routes';
import service from './service/routes';
import food from './food/routes';
import labor from './labor/routes';
import digital from './digital/routes';
import shift from './shift/routes';
import product from './product/routes';
import people from './people/routes';
import payroll from './payroll/routes';

import { calendarRoute } from '@/views/calendar_route';

import {
  addTestRoute,
  useRootStore,
  addPermissionsToRoute,
} from '@qsrsoft/myq-core';

const routes = [
  {
    path: '/home-dashboard',
    alias: '/',
    name: 'Home2',
    coachQName: 'Dashboard',
    icon: 'mdi-home',
    component: () => import('@/components/oldDashboard/mcd/main.vue'),
    async beforeEnter(to, from, next) {
      const store = useRootStore();
      await store.waitForUserToBeLoaded();
      if (store.isCrewMember) {
        window.location.href = '/portal/feed';
      }
      next();
    },
  },
  {
    path: '/reports/mcd/shift-dashboard',
    alias: '/reports/mcd/dashboardtest',
    name: 'Role Based DB',
    icon: 'mdi-home',
    component: () => import('@/views/dashboard/dashboard.vue'),
    async beforeEnter(to, from, next) {
      const store = useRootStore();
      await store.waitForUserToBeLoaded();
      if (store.isCrewMember) {
        window.location.href = '/portal/feed';
      }
      next();
    },
  },
  {
    path: '/schedule',
    name: 'Schedule',
    icon: 'mdi-calendar',
    test: true,
    component: () => import('@/views/schedule/Schedule.vue'),
    async beforeEnter(to, from, next) {
      const store = useRootStore();
      await store.waitForUserToBeLoaded();
      if (!store.isAdmin) {
        return next('/');
      }
      next();
    },
  },
  {
    path: '/qsrConnect',
    name: 'QSR Connect',
    icon: 'mdi-link-variant',
    component: () => import('@/views/mcd/qsrConnect/connect.vue'),
    meta: {
      id: 'qsrconnect',
    },
  },
  {
    path: '/extracts',
    name: 'Extracts',
    component: () => import('./extracts/Extracts.vue'),
    ...addTestRoute(),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('./Test.vue'),
    ...addTestRoute(),
  },
  {
    path: '/reports/mcd/reportFinder',
    name: 'Report Finder',
    icon: 'mdi-file-search-outline',
    meta: { id: 'reports-reportFinder' },
    component: () => import('@/views/mcd/reportFinder/ReportFinder.vue'),
  },
  {
    path: '/customerRecovery/dashboard',
    name: 'Customer Recovery',
    icon: 'mdi-heart-pulse',
    meta: { id: 'reports-customerRecovery' },
    component: () =>
      import('@/views/customerRecovery/pages/CustomerRecoveryDashboard.vue'),
    ...addPermissionsToRoute(['customer_feedback_access']),
  },
  {
    path: '/reports/mcd/recordsv2/dashboard',
    name: 'Campus Training Records',
    meta: { id: 'training-recordsV2' },
    component: () => import('@/views/trainingReport/campusTrainingRecords.vue'),
    ...addPermissionsToRoute(['training_access']),
    beta: true,
  },
  calendarRoute,
  // {
  //   path: '/test',
  //   name: 'Test',
  //   icon: 'mdi-test-tube',
  //   component: () => import('./Test.vue'),
  //   ...addTestRoute(),
  // },
  bu,
  cash,
  food,
  labor,
  digital,
  product,
  people,
  payroll,
  sales,
  service,
  shift,
];

export default routes;
